import React from 'react';
import Avatar from 'components/shared/Avatar/Avatar';
import RadioButton from 'components/shared/RadioButton/RadioButton';
import Spinner from 'components/shared/spinner/spinner';

const UserList = ({
  users = [],
  selectedUser,
  setSelectedUser,
  scrollRef,
  onScroll,
  isFetchingNextPage
}) => (
  <div
    ref={scrollRef}
    onScroll={onScroll}
    className="flex max-h-[calc(100vh-352px)] flex-col gap-0.5 overflow-y-auto px-4 pb-3 pt-2">
    {users.map((u) => (
      <div
        key={u.id}
        onClick={() => setSelectedUser(u)}
        className={`flex cursor-pointer items-center gap-3 rounded-md px-2 py-2 ${selectedUser?.id === u.id ? 'bg-primary-50' : 'hover:bg-neutral-50'}`}>
        <RadioButton
          id={u.id}
          value={u.id}
          isSelected={selectedUser?.id === u.id}
          onChange={() => setSelectedUser(u)}
          wrapperClassName="radio--small !w-auto"
        />
        <Avatar firstName={u.f_name} lastName={u.l_name} id={u?.user_id || u.id} size="large" />
        <p className="text-sm font-500 text-neutral-900">
          {u.f_name} {u.l_name}
        </p>
      </div>
    ))}
    {isFetchingNextPage && (
      <div className="flex justify-center py-2">
        <Spinner />
      </div>
    )}
  </div>
);

export default UserList;
